var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1028.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5966 1030c-0.3905 0.4-0.5966 0.9-0.5966 1.4l-0.0221 7v0.1c0.01903 0.5 0.2035 0.9 0.5303 1.3h0.0663l11.424 11.5c0.782 0.8 2.048 0.8 2.829 0l3.536-3.6 3.535-3.5c0.781-0.8 0.781-2 0-2.8l-11.424-11.5h-0.066c-0.359-0.3-0.828-0.5-1.282-0.5h-0.088-7.0493c-0.5118 0-1.0016 0.2-1.3921 0.6zm1.5026 1.5c0.7811-0.8 2.0474-0.8 2.8285 0 0.781 0.8 0.781 2 0 2.8-0.7811 0.8-2.0474 0.8-2.8285 0-0.781-0.8-0.781-2 0-2.8z",
    fill: "#2ecc71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5938 1030c-0.5119 0-1.047 0.2-1.4376 0.6-0.48 0.5-0.6413 1.2-0.5312 1.8 0.0935-0.3 0.2333-0.6 0.4688-0.8 0.781-0.8 2.0626-0.8 2.8437 0 0.3091 0.3 0.4668 0.7 0.5313 1.1 0.232-0.7 0.0853-1.5-0.4688-2.1-0.3905-0.4-0.8944-0.6-1.4062-0.6zm-3.5313 1c-0.0396 0.1-0.0625 0.3-0.0625 0.5l-0.03125 7v0.1c0.01903 0.4 0.20445 0.9 0.53125 1.3 0.0211 0 0.0401 0 0.0625 0.1l11.438 11.4c0.781 0.7 2.031 0.7 2.812 0l3.563-3.6 3.531-3.5c0.466-0.5 0.621-1.1 0.532-1.7-0.096 0.3-0.242 0.5-0.469 0.8l-3.531 3.5-3.532 3.5c-0.781 0.8-2.062 0.8-2.844 0l-11.406-11.4c-0.0221 0-0.0411-0.1-0.0622-0.1-0.3269-0.3-0.5123-0.8-0.5313-1.3v-6.6z",
    fill: "#1E7A3D"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.70711 .70711 -.70711 .70711 751.53 340.95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-33 1012.4c-0.552 0-1 0.4-1 1v8c0 0.5 0.448 1 1 1h12c0.552 0 1-0.5 1-1v-8c0-0.6-0.448-1-1-1h-12z",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#bdc3c7"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 10,
    x: -32,
    y: 1014.4
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 10,
    x: -32,
    y: 1016.4
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    width: 10,
    x: -32,
    y: 1019.4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagGreen);
export default __webpack_public_path__ + "static/media/tag-green.50232a166f7f5d797c1d6755e4500467.svg";
export { ForwardRef as ReactComponent };